module.exports = __webpack_public_path__ + "static/10-282f7f19e0710e04b20d50768328b2a7.jpg";